import React, { Fragment } from 'react';
import Carousel from 'nuka-carousel';
import './carousel.scss';
import { isValid, getFileName } from '../../../../utils';
import PropTypes from 'prop-types';

class CarouselDots extends React.Component {
  constructor() {
    super();
    this.getIndexes = this.getIndexes.bind(this);
  }

  getIndexes(count, increment) {
    const arr = [];
    for (let i = 0; i < count; i += increment) {
      arr.push(i);
    }
    return arr;
  }

  render() {
    const {
      slideCount,
      slidesToScroll,
      goToSlide,
      currentSlide,
    } = this.props;
    const indexes = this.getIndexes(slideCount, slidesToScroll);
    const renderedCarouselDots = indexes.map(i => (
        <li key={i}
          className={`carousel-dot${currentSlide === i ? ' active' : ''}`}
          onClick={goToSlide.bind(null, i)} />
    ));

    return (
      <ul className="carousel-dots">
        {renderedCarouselDots}
      </ul>
    );
  }
}

CarouselDots.propTypes = {
  slideCount: PropTypes.number,
  slidesToScroll: PropTypes.number,
  goToSlide: PropTypes.func,
  currentSlide: PropTypes.number,
};



class CarouselArrow extends React.Component {
  render() {
    const { direction, previousSlide, nextSlide, currentSlide, slideCount } = this.props;

    if ((direction === 'prev' && currentSlide === 0) || (direction === 'next' && currentSlide === slideCount - 1)) {
      return null; 
    }

    const carouselArrowClassName = `icon-thin-arrow carousel-arrow carousel-arrow-${direction}`;

    return (
      <div
        className={carouselArrowClassName}
        onClick={() => (direction === 'prev' ? previousSlide() : nextSlide())}
      />
    );
  }
}

CarouselArrow.propTypes = {
  direction: PropTypes.string,
  previousSlide: PropTypes.func,
  nextSlide: PropTypes.func,
};

const ImageCarousel = ({ data, isMobile }) => {

  const renderedImages = data.images.map((image, i) => {
    const imgSrc = isMobile ? image.imageSrcMobile : image.imageSrcDesktop;
    const imgAlt = isValid(image.imageAlt) ? image.imageAlt : getFileName(image.imageSrcDesktop);

    return isValid(imgSrc) ? (
      isValid(image.imageUrl) ? (
        <div className="carousel-image" key={i}>
          <a href={image.imageUrl} target="_blank" data-link-type="image-link">
            <img src={imgSrc} alt={imgAlt} />
          </a>
          <div className="carousel-image-credit">{image.credit}</div>
          {isValid(image.caption) && <div className="carousel-image-caption">{image.caption}</div>}
        </div>
      ) : (
        <div className="carousel-image" key={i}>
          <img src={imgSrc} alt={imgAlt} />
          <div className="carousel-image-credit">{image.credit}</div>
          {isValid(image.caption) && <div className="carousel-image-caption">{image.caption}</div>}
        </div>
      )
    ) : null;
  });

  const carouselProps = {
    dragging: true,
    swipping: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    heightMode: 'max',
  };

  return (
    <div className="image-carousel">
       <Carousel
          {...carouselProps}
          renderCenterLeftControls={props => (<CarouselArrow direction="prev" {...props} />)}
          renderCenterRightControls={props => (<CarouselArrow direction="next" {...props} />)}
          renderBottomCenterControls={props => (<CarouselDots {...props} />)}>
        {renderedImages}
      </Carousel>
    </div>
  );
};

ImageCarousel.propTypes = {
  data: PropTypes.object,
};

export default ImageCarousel;
